/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/Arrive': {
    width: 111,
    height: 110,
    viewBox: '0 0 111 110',
    data: '<ellipse pid="0" cx="55.5" cy="55" rx="55.5" ry="55" _fill="#246D95"/><path pid="1" d="M55.041 66.79C41.172 66.79 30 70.966 30 76.287c0 5.317 11.172 9.499 25.041 9.499 13.87 0 25.042-4.178 25.042-9.5 0-5.32-11.172-9.498-25.041-9.498zm0 13.294c-9.633 0-17.337-1.71-17.337-3.8s7.704-3.8 17.337-3.8c9.634 0 17.338 1.71 17.338 3.8s-7.704 3.8-17.338 3.8z" _fill="#fff"/><path pid="2" d="M55.041 25c-9.633 0-17.337 7.597-17.337 17.096 0 9.5 17.337 36.09 17.337 36.09S72.38 51.592 72.38 42.097C72.379 32.597 64.674 25 55.04 25zm0 24.693c-4.236 0-7.704-3.42-7.704-7.597 0-4.178 3.468-7.597 7.704-7.597 4.237 0 7.705 3.42 7.705 7.597 0 4.178-3.468 7.597-7.705 7.597z" _fill="#fff"/>'
  }
})
